import React from 'react';
import { Link } from 'react-router-dom';
export function SubpageHeader() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-[#09090B]" data-id="element-114">
      <div className="container mx-auto px-6 md:px-12 h-24 flex items-center justify-between" data-id="element-115">
        <Link to="/" className="group focus:outline-none" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/u58yyudAVGYZM45T7aPn3Z/PP_Logo_Lime.svg" alt="HBS Impact" className="h-20 md:h-24 w-auto p-1.5 transition-opacity group-hover:opacity-80" data-id="element-117" />
        </Link>

        <div className="flex items-center gap-4 md:gap-8" data-id="element-118">
          <Link to="/#contact" className="hidden md:block font-mono text-xs md:text-sm tracking-[0.2em] text-muted hover:text-white transition-colors focus:outline-none" data-id="element-119">
            KONTAKT
          </Link>
          <Link to="/#cta" className="bg-lime text-bg px-4 py-3 md:px-6 md:py-3 font-mono text-xs md:text-sm font-bold tracking-[0.1em] md:tracking-[0.2em] transition-all duration-300 hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-lime focus:ring-offset-2 focus:ring-offset-bg" data-id="element-120">
            GESPRÄCH VEREINBAREN
          </Link>
        </div>
      </div>
    </header>;
}